import React from 'react'
import { classNames } from '../../utils/classNames'

const Phone = ({ className, ...svgProps }) => (
  <svg className={classNames('icon', className)} {...svgProps}>
    <use
      xlinkHref={`/Static/Images/icons.svg?=${
        process.env.BUILD_VERSION_ID
      }#icon--phone`}
    />
  </svg>
)

export default Phone
